export function GoogleSignin(): void {
  /* no-op */
}
